<template>
  <div class="icon-selector">
    <div class="selected-icon-preview mb-2">
      <i :class="'fas fa-' + (value || fallback)" class="fa-2x"></i>
      <span class="ms-2 text-muted">{{ value || fallback }}</span>
    </div>
    <div class="icon-search mb-2">
      <input
        type="text"
        class="form-control form-control-sm"
        v-model="iconSearch"
        :placeholder="$t('SearchIcon')"
      />
    </div>
    <div class="icon-grid">
      <button
        type="button"
        v-for="icon in filteredIcons"
        :key="icon"
        class="icon-option"
        :class="{ selected: value === icon }"
        @click="$emit('input', icon)"
        :title="icon"
      >
        <i :class="'fas fa-' + icon"></i>
      </button>
    </div>
  </div>
</template>

<script>
import { AVAILABLE_ICONS } from "@/utils/pickableIcons";

export default {
  name: "IconPicker",
  props: {
    value: {
      type: String,
      default: "",
    },
    // Ícono que se muestra en la vista previa cuando no hay ninguno elegido.
    fallback: {
      type: String,
      default: "file-alt",
    },
  },
  data() {
    return {
      iconSearch: "",
    };
  },
  computed: {
    filteredIcons() {
      if (!this.iconSearch.trim()) {
        return AVAILABLE_ICONS;
      }
      const search = this.iconSearch.toLowerCase();
      return AVAILABLE_ICONS.filter(icon => icon.includes(search));
    },
  },
};
</script>

<style scoped>
.icon-selector {
  border: 1px solid #dee2e6;
  border-radius: 0.375rem;
  padding: 0.75rem;
  background-color: #f8f9fa;
}

.selected-icon-preview {
  display: flex;
  align-items: center;
  padding: 0.5rem;
  background: white;
  border-radius: 0.25rem;
  border: 1px solid #e9ecef;
}

.icon-grid {
  display: grid;
  grid-template-columns: repeat(8, 1fr);
  gap: 0.25rem;
  max-height: 200px;
  overflow-y: auto;
  padding: 0.5rem;
  background: white;
  border-radius: 0.25rem;
  border: 1px solid #e9ecef;
}

.icon-option {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border: 1px solid transparent;
  background: transparent;
  border-radius: 0.25rem;
  cursor: pointer;
  transition: all 0.15s ease;
  color: #495057;
}

.icon-option:hover {
  background-color: #e9ecef;
  border-color: #dee2e6;
}

.icon-option.selected {
  background-color: #0d6efd;
  color: white;
  border-color: #0d6efd;
}

.icon-option i {
  font-size: 1rem;
}
</style>
